/**
 * Legal PDFs linked from the registration consent. They are the same files as in the footer of
 * claystudio.sk, hosted by Hostinger under a random name: re-uploading a PDF there gives it a new
 * URL, so update it here too (docs/10-hostinger-embed.md).
 */
export const LEGAL_DOCS = {
  terms: "https://assets.zyrosite.com/SJO5kQW0KC1SS5lz/vop-clay-s.r.o.-QB3wlhp7BAp9UV5R.pdf",
  studioRules: "https://assets.zyrosite.com/SJO5kQW0KC1SS5lz/pravidla-studia-ibVFOEhboc1SASXi.pdf",
  privacy: "https://assets.zyrosite.com/SJO5kQW0KC1SS5lz/gdpr_clay-nVee1YqSzOTuPAuY.pdf",
};
